<template>
  <div>
    <div class="flex flex-col gap-5 px-4 md:flex-row">
      <div class="te-title-bg flex flex-col items-center justify-center px-10 py-0 md:py-10">
        <img
          class="te-pc-text hidden md:block"
          src="~/assets/images/Te/TeCommon/Graduate/Movies/watch_movie_pc.png"
          alt="動画で見る"
          loading="lazy"
        >
        <img
          class="te-sp-text block md:hidden"
          src="~/assets/images/Te/TeCommon/Graduate/Movies/watch_movie_sp.png"
          alt="動画で見る"
          loading="lazy"
        >
        <div class="te-title-sub mt-2 text-co-gray-500">
          受講生の声 01/02
        </div>
      </div>
      <iframe
        class="aspect-video flex-1"
        src="https://www.youtube.com/embed/CsCpI4THD30?rel=0"
        loading="lazy"
        allowfullscreen
      />
      <iframe
        class="aspect-video flex-1"
        src="https://www.youtube.com/embed/1ZKxwvrHpUA?rel=0"
        loading="lazy"
        allowfullscreen
      />
    </div>
    <p class="mx-4 mb-0 mt-3 text-sm text-gray-500">
      WebデザインコースでもWebコーディングの仕事をできるようになります。
    </p>
  </div>
</template>

<style scoped>
.te-pc-text {
  width: 7.5rem;
}

.te-sp-text {
  width: 13.75rem;
}

.te-title-bg {
  background: none;
}

.te-title-sub {
  font-size: 1rem;
}

@media (min-width: 768px) {
  .te-title-bg {
    background: #f6f8f7;
  }
  .te-title-sub {
    font-size: 0.875rem;
  }
}
</style>
